import React from 'react';
import './IaReport.css';
import NotUnderstood from './NotUnderstood';
import PerformanceIntentions from './PerformanceIntentions';
import UseIntentions from './UseIntentions';

const IaReport = ({ subPageIa }) => {
  const pages = {
    aiNotUnderstood: <NotUnderstood />,
    aiUseIntentions: <UseIntentions />,
    aiIntentionPerformance: <PerformanceIntentions />,
  };

  return <div className="container-all-history">{pages[subPageIa]}</div>;
};

export default IaReport;
